import React from 'react';
import { Modal } from '@material-ui/core';

import { useDispatch, useSelector } from '../../../../../lib/react-redux-hooks';
import {
  closePreapprovedTrueModal,
  openPreapprovedContactModal,
  openFileUploadModal,
} from '../../../../../actions/dashboard';
import { renderInitialPart } from './PreapprovedFalseModal';
import styles from '../../../../../styles/sass/components/GetPreapproved.module.scss';
import { connect } from 'react-redux';

interface Props {
  modalStyle: any;
  dispatch: Function;
  showPreapprovedTrueModal: boolean;
}

export const PreapprovedTrueModal: React.FC<Props> = ({
  modalStyle,
  showPreapprovedTrueModal,
  dispatch,
}) => {
  const handleGetStarted = () => {
    dispatch(closePreapprovedTrueModal());
    dispatch(openFileUploadModal());
  };

  return (
    <Modal
      open={showPreapprovedTrueModal}
      onClose={() => dispatch(closePreapprovedTrueModal())}
      style={modalStyle}
    >
      <div className={styles.preapprovedTrueModal}>
        {renderInitialPart(dispatch)}
        <div className={styles.requirementsContainer}>
          <p className={styles.headText}>
            In order to complete this task, you will need to upload the
            following document:
          </p>
          <ul style={{ margin: '10px 10px' }}>
            <li>Your preapproval letter</li>
          </ul>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={handleGetStarted}>
            Get started
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  showPreapprovedTrueModal: state.dashboard.showPreapprovedTrueModal,
});

export default connect(mapStateToProps)(PreapprovedTrueModal);
